import styled from "styled-components";
import Accordion from "@mui/material/Accordion";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Alert from "@mui/material/Alert";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import Button from "components/LoadingButton";
import MButton from "@mui/material/Button";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import { getBackgroundColorByArtProof } from "components/OrderCard/utils";

export const StyledContainer = styled(Container)``;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const StyledHeader = styled.div`
  position: relative;
  .actions {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    gap: 10px;

    button {
      padding: 4px 10px;
      font-size: 11px;
    }
    button:nth-child(2) {
      background: red;
      :hover {
        background: red;
      }
    }
    button:nth-child(3) {
      background: green;
      :hover {
        background: green;
      }
    }
  }
`;

export const FormRow = styled.div`
  display: flex;
  padding-top: 10px;
  flex: 1;
  gap: 20px;

  .MuiAutocomplete-root {
    width: 100%;
  }
`;

export const Dates = styled.div`
  display: flex;
  gap: 20px;
  margin-top: ${({ noMarginTop }) => (noMarginTop ? 0 : "20px")};
`;

export const FormFields = styled.div`
  flex: 1;
  position: relative;
`;

export const UploadPOContainer = styled.div`
  flex: 1;
  position: relative;

  svg.download {
    position: absolute;
    top: 4px;
    right: 30px;
    cursor: pointer;
  }
  svg.edit {
    position: absolute;
    top: 4px;
    right: 4px;
    cursor: pointer;
    width: 20px;
  }
`;

export const UploadPO = styled.div`
  width: 200px;
  border: 1px dashed #a1a1a1;
  justify-content: center;
  align-items: center;
  display: flex;
  cursor: ${(props) => (props?.disabled ? "no-drop" : "pointer")};
  flex-direction: column;
  opacity: ${(props) => (props?.disabled ? 0.3 : 1)};
  flex: 1;

  svg.pdf {
    font-size: 40px;
    color: #a1a1a1;
  }

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80%;
    white-space: nowrap;
    color: black;
    text-align: center;
  }
`;

export const OrderInfoContainer = styled.div`
  padding: 12px;
  .row {
    display: flex;
    gap: 20px;
  }
  .col {
    flex: 1;
    iframe {
      width: 100%;
      min-height: 600px;
    }

    .upload-artproof {
      display: flex;
      justify-content: center;
      height: 140px;
      cursor: pointer;
    }

    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .MuiStepContent-root,
  .MuiStepConnector-root {
    margin-left: 19px;

    .MuiTypography-root {
      color: #a1a1a1;
      font-size: 12px;
    }
  }
`;

export const ArtProofStatus = styled.span`
  text-transform: capitalize;
  padding-left: 4px;
  color: ${({ artProof }) => getBackgroundColorByArtProof(artProof)}; ;
`;

export const ArtProofTitle = styled.span`
  font-size: 12px;
  color: #ccc;
`;

export const StepperLabel = styled.div`
  display: flex;
  justify-content: space-between;

  .MuiTypography-root {
    color: #a1a1a1;
    font-size: 12px;
  }
`;

export const ArtproofActions = styled.div`
  justify-content: center;
  display: flex;
  gap: 10px;
  height: 40px;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
`;

export const EditArtProofButton = styled(Button)`
  &.MuiButtonBase-root {
    min-width: 40px;
  }

  .MuiButton-startIcon {
    margin-right: 0;
    margin-left: 0;
  }
`;

export const ArtProofIframe = styled.iframe`
  border: ${({ artProof }) =>
    `3px solid ${getBackgroundColorByArtProof(artProof)}`};
`;

export const Notes = styled.h3`
  margin-top: 0;
`;

export const OrderDocuments = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  padding-right: 20px;
`;

const getFRs = (arr) => {
  let value = "";

  for (let i = 0; i < arr?.length; i += 1) {
    value += "1fr ";
  }
  return value;
};

export const DecorationsInProductionDate = styled.div`
  display: grid;
  grid-template-columns: ${({ decorations }) => getFRs(decorations)};
  gap: 10px;
  margin-top: 20px;
`;

export const StyledArtfiles = styled(Paper)`
  margin-top: 20px;
  padding: 14px;

  .header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid black;
    align-items: center;
    padding-bottom: 5px;
    font-size: 18px;
    font-weight: bold;
    svg {
      cursor: pointer;
    }
  }
`;

export const NoArtfileFound = styled(Alert)`
  margin-top: 10px;
`;

export const StyledSubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 26px;
  margin-bottom: 10px;
  gap: 20px;

  .company-address-line-one,
  .company-address,
  .company-email {
    font-size: 14px;
  }
`;

export const StyledSubHeader1 = styled.div`
  display: grid;
  justify-content: space-between;
  line-height: 26px;
  margin-bottom: 10px;
  gap: 20px;
  grid-template-columns: 1fr 2fr 1fr;
  grid-auto-flow: column;

  .company-address-line-one,
  .company-address,
  .company-email {
    font-size: 14px;
  }
`;

export const OrderEstimationDialogBody = styled(Container)`
  margin: 15px;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : "20px")};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? "10px" : 0)};
`;

export const InvoiceDetails = styled.div``;

export const Address = styled.div`
  margin-top: 10px;
`;

export const ShipTo = styled.div``;

export const Row = styled.div`
  margin-bottom: 8px;
  display: flex;
  gap: 20px;
`;

export const LineItems = styled.div`
  .MuiOutlinedInput-root {
    background-color: white;
  }
`;

export const LineItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #000;
  margin-bottom: 14px;
  margin-top: 20px;
  align-items: center;

  h2 {
    margin: 0;
  }
`;

export const LineItemFooter = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;

  svg {
    cursor: pointer;
  }
`;

export const Heading = styled.h3`
  margin: 0;
`;

export const Layer = styled.div`
  position: absolute;
  cursor: no-drop;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9;
`;

export const Total = styled.div`
  display: flex;
  gap: 20px;
  font-weight: bold;
  margin: 50px 0 10px;
  .thanks {
    flex: 1;
  }
  .table {
    .row {
      display: flex;
      gap: 20px;
      padding-bottom: 10px;
      .col {
        flex: 1;
      }
    }
  }
`;

export const LineItem = styled.div`
  margin: 20px 0;
  display: flex;
  width: 500px;
  gap: 20px;
`;

export const StyledDecoratorRow = styled.div`
  border-bottom: 1px dashed black;
  margin-bottom: 10px;
  padding-bottom: 10px;
`;

export const StyledChips = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const StyledDecorations = styled.div`
  margin-bottom: 10px;
  margin-left: 30px;
`;

export const StyledNote = styled.p`
  color: red;
  padding: 5px 0;
  margin: 0;
  font-size: 13px;
`;

export const DecoratortWorkDialogWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  height: 100%;
`;

export const PoSecureUrl = styled.div`
  display: flex;
  flex-direction: column;
  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    flex: 1;
  }
`;

export const WorkOrderWrapper = styled.div`
  padding: 10px;
`;

export const WorkOrderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .address {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    .company-email,
    .company-location,
    .company-address {
      font-size: 12px;
    }
  }
  .logo {
    img {
      width: 150px;
    }
  }
`;

export const WorkOrderTitle = styled.h3`
  margin: 10px 0;
`;

export const StyledShipTo = styled.div`
  padding: 15px;
  margin-bottom: 15px;
`;

export const ShipToRow = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
`;

export const StyledTableRow = styled.div`
  padding: 15px;
  border-bottom: 1px solid #f8f8f8;
  background-color: ${(props) => (props?.even ? "#f8f8f8" : "transparent")};
  position: relative;
`;

export const StyledTableRow1 = styled.div``;

export const StyledTableRow2 = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 15px;
`;

export const WorkOrderHeading = styled.div`
  background: black;
  color: white;
  padding: 15px;
  font-weight: bold;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledDisabledByDefaultIcon = styled(DisabledByDefaultIcon)`
  &.MuiSvgIcon-root {
    position: absolute;
    right: -2px;
    top: -3px;
    font-size: 20px;
    color: #cc0003;
    cursor: pointer;
    :hover {
      color: #a23225;
    }
  }
`;

export const SubmitButton = styled(MButton)`
  &.MuiButtonBase-root {
    color: white;
  }

  &.Mui-disabled {
    color: white !important;
    opacity: 0.4;
  }
`;

export const StyledAddress = styled.div`
  font-size: 12px;
  color: #8e8383;
  margin-bottom: 20px;
`;

export const TextAreaWrapper = styled.div`
  width: 100%;
  p {
    margin: 0;
    font-weight: bold;
    font-size: 12px;
    padding-bottom: 5px;
  }
`;

export const DecorationTitle = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const DecorationImage = styled(Avatar)`
  &.MuiAvatar-root {
    width: 24px;
    height: 24px;
  }
`;

export const StyledAccordion = styled(Accordion)`
  .Mui-disabled {
    background-color: white !important;
    opacity: 1 !important;
  }
`;

export const StyledRushOrder = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  color: red;
  font-size: 13px;
  padding: 4px;
  font-weight: bold;
  border: 1px solid red;
  border-radius: 4px;
  svg {
    font-size: 18px;
  }

  :hover {
    background-color: red;
    color: white;

    svg {
      color: white;
    }
  }
`;

export const StyledComments = styled.div`
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  padding-left: 20px;
  max-width: 300px;
`;
export const StyledCommentsTitle = styled.h3`
  margin: 0;
`;
export const StyledAllComments = styled.div`
  margin-top: 20px;
`;

export const StyledCheckInButton = styled(MButton)``;

export const StyledRow = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
`;

export const StyledCheckInsWrapper = styled.div`
  padding: 12px;
  h3 {
    margin: 0;
    border-bottom: 1px solid #000;

    margin-bottom: 15px;
    font-weight: 400;
    font-size: 1.5rem;
    line-height: 1.334;
    letter-spacing: 0em;
  }
`;

export const DatesTitle = styled.h3`
  margin: 0 0 20px 0;
  border-bottom: 1px solid black;
  padding-bottom: 5px;
`;

export const EditOrderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`;
